export default function formatCentsToEurs(cents) {
  const euros = cents / 100;
  return euros.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}
